import { useMutation, useQueryClient } from "@tanstack/react-query"
import { useRouter } from "@tanstack/react-router"
import axios from "axios"
import { setAuthToken } from "modules/auth/lib/setAuthToken"
import { BackofficeImpersonateOrganizationResponseDataSchema, DataResponse } from "schema"
import { z } from "zod"

type Props = {
  organizationId: string
  customerId: string
  conversationId: string
  questionId?: string
}

export function useOpenBackofficeConversation() {
  const { buildLocation } = useRouter()
  const queryClient = useQueryClient()
  return useMutation({
    retry: false,
    mutationFn: async ({ organizationId, customerId, conversationId, questionId }: Props) => {
      const link = buildLocation({
        to: "/conversations/list/$customerId",
        params: { customerId },
        search: { tab: "support", conversationId: Number(conversationId), questionId },
      }).href
      type Response = DataResponse<
        z.infer<typeof BackofficeImpersonateOrganizationResponseDataSchema>
      >
      const { data } = await axios.get<Response>(
        `/backoffice/organizations/impersonate/${organizationId}`,
      )
      setAuthToken({ queryClient, token: data.data.token })
      window.open(`${window.location.origin}${link}`, "_blank", "noopener,noreferrer")
    },
  })
}
